import { COLOR_BLUE_700 } from '@alltrails/denali/tokens';
import { createCircleMarker } from './svgMarkerComponents';

const userCustomMapPinClusterSvg = createCircleMarker({
  imageName: 'user-custom-map-pin-cluster',
  innerDiameter: 24,
  innerFill: COLOR_BLUE_700
});

export default userCustomMapPinClusterSvg;
